var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGameActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 3,
    width: 9,
    height: 14,
    transform: "rotate(90 19 3)",
    fill: "#F9DF35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 9,
    height: 6,
    transform: "rotate(90 19 13)",
    fill: "#F2F1F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 8,
    height: 7,
    transform: "rotate(90 12 13)",
    fill: "#EFEEF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2294 0.757036C14.3701 0.319055 9.63002 0.319127 4.77072 0.757132C3.52425 0.869484 2.55374 1.87416 2.47238 3.11698C2.08701 9.00417 2.08701 15.0888 2.47238 20.976C2.55374 22.2187 3.52425 23.2234 4.77072 23.3357C9.63003 23.7737 14.3701 23.7737 19.2294 23.3357C20.4758 23.2233 21.4463 22.2187 21.5277 20.9758C21.9131 15.0887 21.9131 9.00406 21.5277 3.1169C21.4463 1.87406 20.4758 0.869383 19.2294 0.757036ZM6.10401 9.90098V5.82552C6.10401 4.87874 6.87151 4.11123 7.81829 4.11123H16.1818C17.1285 4.11123 17.896 4.87874 17.896 5.82552V9.90098C17.896 10.8477 17.1285 11.6153 16.1818 11.6153H7.81829C6.87153 11.6153 6.10401 10.8477 6.10401 9.90098ZM9.7409 15.4286C9.7409 14.8369 9.26121 14.3572 8.66947 14.3572C8.07773 14.3572 7.59804 14.8369 7.59804 15.4286V16.0715H6.95518C6.36345 16.0715 5.88376 16.5512 5.88376 17.1429C5.88376 17.7346 6.36345 18.2143 6.95518 18.2143H7.59804V18.8572C7.59804 19.4489 8.07773 19.9286 8.66947 19.9286C9.26121 19.9286 9.7409 19.4489 9.7409 18.8572V18.2143H10.3838C10.9755 18.2143 11.4552 17.7346 11.4552 17.1429C11.4552 16.5512 10.9755 16.0715 10.3838 16.0715H9.7409V15.4286ZM17.2902 16.79C17.2902 16.1982 16.8105 15.7185 16.2188 15.7185C15.627 15.7185 15.1473 16.1982 15.1473 16.79V17.4958C15.1473 18.0876 15.627 18.5673 16.2188 18.5673C16.8105 18.5673 17.2902 18.0876 17.2902 17.4958V16.79Z",
    fill: "#13100F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameActive);
export default __webpack_public_path__ + "static/media/icon_game_active.aa357792eabaae427a956e97324c1d32.svg";
export { ForwardRef as ReactComponent };